module.exports = __webpack_public_path__ + "fonts/slider_handles.1868e2550c9853a938a6211d196f9dcd.png?";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/images/slider_handles.png
// module id = 914
// module chunks = 5